























import Vue from 'vue'
import { SearchFacets } from '@/search/types'
import { TextLink } from '@raksul/raksul-common-ui'
import { FACET_QUERY_PREFIX } from '@/search/const'
export default Vue.extend({
  components: {
    TextLink
  },
  props: {
    categoryId: {
      type: Number,
      required: true
    },
    facetItem: {
      type: Object as () => SearchFacets,
      required: true
    }
  },
  methods: {
    urlLinkFacet(facetValue: string): string {
      return `/search?category=${this.categoryId}&${FACET_QUERY_PREFIX}${this.facetItem.facetKeyName}=${facetValue}`
    }
  }
})
